import Model from './Model';
import Asset from './Asset';
import { v1 } from 'uuid';


export default class CustomizationNode extends Model {
  static type = 'customizationNodes';

  configuration: any;
  customizationType: string;
  asset: Asset;
  draggable: boolean;
  editable: boolean;
  position: number;

  static init(data: any) {
    const node = new CustomizationNode({});
    node.id = data.id || v1();
    node.draggable = data.draggable || false;
    node.editable = data.editable || false;
    node.customizationType = data.customizationType
    node.position = data.position;
    node.configuration = data.configuration;
    node.asset = data.asset;
    return node;
  }

}
